<template>
  <div id="app" :class="isPC && 'app-pc'">
    <TUICallKit class="callkit-container" 
    :videoDisplayMode="VideoDisplayMode.CONTAIN"
    style="z-index: 9999"
    :allowedMinimized="true"  :allowedFullScreen="true" />
    <router-view></router-view>
    <Upgrade />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import { TUICallKit, TUICallKitServer, TUICallType, VideoDisplayMode  } from '@tencentcloud/call-uikit-vue2';
import { TUICallEvent } from 'tuicall-engine-webrtc';
import myJsTools from "@/utils/myJsTools";
import TencentCloudChat from '@tencentcloud/chat';
import { startLoading, stopLoading  } from '@/utils/public';
import { Toast } from 'vant';
import { getUserSig } from '@/utils/userSigUtils';
import { TUILogin } from '@tencentcloud/tui-core';
import { framework } from './TUIKit/adapter-vue';
import Upgrade from '@/components/Upgrade.vue';
import { getPlatform } from '@tencentcloud/universal-api';
import { mapActions } from "vuex";
import {getDoctorInfoByDocId} from "@/api/my";
import {getSysPlatformConfigBykey} from "@/api/login";
import store from '@/store/store'

export default {
  components: {
    TUICallKit,
    Upgrade
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLogin;
    }
  },
  data() {
    return {
      remainingTime: 0, // 剩余时间（毫秒）
      timerTX: null, // 定时器ID
      curSdkId: 0,
      isPC: getPlatform() === 'pc',
      VideoDisplayMode,
      // isLogin: localStorage.getItem('isLogin') || 0
    }
  },
  watch: {
    isLoggedIn(newVal, oldVal) {
      const userID = myJsTools.getItem('tencentInfo')?.userID;
      stopLoading()
      if (newVal && newVal == 1) {
        if (userID) {
          this.$tracker.setUserId(userID)
          this.getDBLOG_WHITE_LIST();
        }
        this.txLogin()
        const curTencentInfo = myJsTools.getItem('tencentInfo')
        this.curSdkId = curTencentInfo.SDKAppID
        let options = {
          SDKAppID: curTencentInfo.SDKAppID
        };
        if(!options.SDKAppID) return;
       let chat = TencentCloudChat.create(options);
        chat.on(TencentCloudChat.EVENT.SDK_READY, this.onSDKReady)
        chat.on(TencentCloudChat.EVENT.SDK_NOT_READY, this.onSdkNotReady)
        chat.on(TencentCloudChat.EVENT.KICKED_OUT, this.handleOnKickedOut)
        // this.judgeISExpire()
        // 连接websocket
        let docId = '';
        if (myJsTools.getItem('docUserInfo') && myJsTools.getItem('docUserInfo').docId) {
          docId = myJsTools.getItem('docUserInfo').docId;
        };
        this.initWebSocket(docId);
      } else {
        const callEngine = TUICallKitServer.getTUICallEngineInstance();
        if (callEngine) {
          // 退出时off
          callEngine.off(TUICallEvent.ERROR, this.handleTUICallKitError);
        }
        this.$tracker.clearUserId()
         let options = {
          SDKAppID: this.curSdkId
        };
        if(!options.SDKAppID) return;
        let chat = TencentCloudChat.create(options);
        chat.off(TencentCloudChat.EVENT.SDK_READY, this.onSDKReady)
        chat.off(TencentCloudChat.EVENT.SDK_NOT_READY, this.onSdkNotReady)
        chat.off(TencentCloudChat.EVENT.KICKED_OUT, this.handleOnKickedOut)
        this.curSdkId = 0
        try {
          TUILogin.logout()
        } catch (error) {
          
        }
      }
    }
  },
  mounted() {
    const userID = myJsTools.getItem('tencentInfo')?.userID;
    if(userID) {
      this.$tracker.setUserId(userID)
    }
    this.getDocInfo()

    this.$tracker.send({
      message: '#启动#-APP-mounted',
      content: ''
    })
    // window.addEventListener('storage', () => this.checkLogin())
  },
  // destroyed() {
  //   window.removeEventListener('storage', () => this.checkLogin())
  // },
  methods: {
    ...mapActions("msg", ["initWebSocket"]),
    txLogin() {
      const userID = myJsTools.getItem('tencentInfo')?.userID;
      const userSig = myJsTools.getItem('tencentInfo')?.userSig;
      const SDKAppID = myJsTools.getItem('tencentInfo')?.SDKAppID;
      TUILogin.login({
        SDKAppID: SDKAppID,
        userID: userID,
        userSig: userSig,
        useUploadPlugin: true,
        framework,
      }).then((res) => {
        stopLoading()
        console.log('TUILogin登录成功', res);
        this.$tracker.send({
          message: '#SDK_TUIKIT#',
          content: JSON.stringify({ data: 'TUILogin登录成功' }),
          level: 'info',
          docName: myJsTools.getItem("docUserInfo")?.docName || ''
        })
        this.$store.commit("setTxLogined", true);
      })
      .catch((error) => { 
        stopLoading()
        console.log('TUILoginerror',error);
        this.$tracker.sendError({
          errorMessage: JSON.stringify(error),
          errorType: '#SDK_TUIKIT#-warn',
          errorStack: 'Error stack trace...'
        })
        if (error.message) {
          Toast(error.message)
        }
      })
    },
    judgeISExpire() {
      const expirationTime = myJsTools.getItem('expirationTime');
      if (expirationTime) {
        const currentTime = new Date().getTime();
        this.remainingTime = expirationTime - currentTime;

        // 如果时间已经过期，直接重新登录
        if (this.remainingTime <= 0) {
          this.redirectToLogin();
        } else {
          // 启动倒计时
          this.startCountdown();
        }
      } else {
        // 如果没有过期时间，重定向到登录页面
        this.redirectToLogin();
      }
    },
    startCountdown() {
      // 每秒更新倒计时
      this.timerTX = setInterval(() => {
        this.remainingTime -= 1000;
        if (this.remainingTime <= 0) {
          clearInterval(this.timerTX); // 清除定时器
          this.redirectToLogin(); // 重新获取usersign
        }
      }, 1000);
    },
    async redirectToLogin() {
      console.log('redirectToLoginredirectToLogin');
      // this.getUserSig()
      const result = await getUserSig();
      this.txLogin()
      if (result.success) {
        stopLoading()
        this.judgeISExpire()
      } else {
        console.error('getUserSig in redirectToLogin', result);
      }
    },
    checkLogin() {
      let curDocId = myJsTools.getItem('curDocId');
      let newDocId = sessionStorage.getItem('userId');
      console.log('this.$routethis.$route', this.$route)
      if (curDocId && newDocId &&  curDocId != newDocId ) {
        Toast('不能等多个账号')
        this.$router.push({
          path: "/login"
        })
      }
    },
    onSDKReady() {
      stopLoading()
      // this.listenersCall()
      this.initializeCallKit()
    },
    onSdkNotReady() {
      console.log('触发初始化没有ready事件');
      startLoading({
        text: 'sdk加载中'
      })
      //  const curTencentInfo = myJsTools.getItem('tencentInfo')
      // let options = {
      //   SDKAppID: curTencentInfo.SDKAppID
      // };
      // chat.login({userID: curTencentInfo.userID, userSig: curTencentInfo.userID})
    },
    // handleKickedOut() {
    //   console.log("[TUICallkit Demo] kickedOut");
    // },
    listenersCall() {
      const curTencentInfo = myJsTools.getItem('tencentInfo')
      let options = {
        SDKAppID: curTencentInfo.SDKAppID
      };
      let chat = TencentCloudChat.create(options);
      chat.on(TencentCloudChat.EVENT.KICKED_OUT, this.handleOnKickedOut)
    },
    async initializeCallKit() {
      console.log('组件已挂载');
      
      try {

        await TUICallKitServer.init({
          SDKAppID: myJsTools.getItem('tencentInfo')?.SDKAppID,
          userID: myJsTools.getItem("docAllInfo")?.docId,
          userSig:  myJsTools.getItem('tencentInfo')?.userSig,
        });
        console.log("[TUICallKit] Initialization succeeds.");
        this.$tracker.send({
          message: '用户登录成功',
          content: JSON.stringify({ data: '[TUICallKit] Initialization succeeds.' }),
          level: 'info',
          docName: myJsTools.getItem("docUserInfo")?.docName || ''
        })

        const callEngine = TUICallKitServer.getTUICallEngineInstance();
        if (callEngine) {
          // 👇 关键：额外监听 ERROR 事件上报日志，退出时off
          callEngine.on(TUICallEvent.ERROR, this.handleTUICallKitError);
        }
      } catch (error) {
        console.error(`[TUICallKit] Initialization failed. Reason: ${error}`);
        this.$tracker.sendError({
          errorMessage: `[TUICallKit] Initialization failed. Reason: JSON.stringify(${error})`,
          errorType: '#SDK_TUIKIT#-warn',
          errorStack: 'Error stack trace...'
        })
      }
    },
    handleOnKickedOut(e) {
      console.log('被踢了被踢了被踢了', e);
      Toast('当前用户被踢下线，请重新登录')
      this.$tracker.sendError({
        errorMessage: '当前用户被踢下线，请重新登录',
        errorType: '#SDK_TUIKIT#-warn',
        errorStack: 'Error stack trace...'
      })
      myJsTools.clearLogInfo(this.$store)
      this.$router.push({
        path: "/login"
      })
    },
    getDocInfo() {
      console.log('myJsTools.getItem("token_info")?.docId', myJsTools.getItem("token_info")?.docId);
      if(!myJsTools.getItem("token_info")?.docId) return;
      getDoctorInfoByDocId({
        docId: myJsTools.getItem("token_info")?.docId
      }).then(async res => {
        myJsTools.setItem("docAllInfo", res?.data);
        store.commit('msg/UPDATE_SOUND_CONFIG', res?.data?.voiceSwitch == '1');
        if(res?.data) {
          this.getDBLOG_WHITE_LIST();
        }
      });
    },
    // 获取DB白名单
    getDBLOG_WHITE_LIST() {
      // const currentUser = myJsTools.getItem('docAllInfo')?.telNo
      // if (currentUser) {
      //   // 获取DB日志白名单
      //   getSysPlatformConfigBykey({
      //     configKey: "DBLOG_WHITE_LIST"
      //   }).then(res => {
      //     setupLogger({
      //       enableUsers: (res?.data?.configValue||'').split(','),
      //       currentUser
      //     })
      //   })
      // }
    },
    // 错误上报到日志系统
    handleTUICallKitError(event) {
      const { code, message } = event || {};
      this.$tracker.sendError({
        errorMessage: `[TUICallKit] Business error. Code: ${code}, Message: ${message}`,
        errorType: '#SDK_TUIKIT#-warn',
        errorStack: 'Error stack trace...'
      })
    },
    
  }
}

// export default class App extends Vue {
//   async mounted() {
//     this.initializeCallKit();
//   }
//       // 初始化方法
// }
</script>

<style lang="less">
@import "./assets/css/overall";

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  font-size: 14px;
  background: #fff;
  height: 100%;
}
.app-pc {
}

/deep/ .van-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);  
}

.loadingPopup {
  width: 100%;
  height: 100%;
  background: inherit;
}
/* App.vue 或 main.css */

* {
  /* 让所有元素继承这个滚动条样式 */
  scrollbar-width: thin;  /* Firefox */
  scrollbar-color: #F5F5F6 #fff; /* Firefox */
}

::-webkit-scrollbar {
  width: 2px; /* 滚动条的宽度 */
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* 滚动条轨道的颜色 */
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #F5F5F6; /* 滚动条滑块的颜色 */
  border-radius: 10px;
  border: 3px solid #f1f1f1; /* 滑块与轨道之间的边距 */
}

::-webkit-scrollbar-thumb:hover {
  background-color: #F5F5F6; /* 滑块悬停时的颜色 */
}

::-webkit-scrollbar-button {
  display: none;  /* 隐藏上下箭头 */
}
</style>

  